import { LOADING_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ pii, token }) => `/enhancements/article/pii/${pii}/recommendations?token=${token}`,
  },
  fetch: createFetcher(
    LOADING_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS_FAILED,
  ),
};
